import { OrderPlanningActions } from "../../OrderPlanningActions";
import { PlanningTitle } from "../../PlanningTitle";
import { Button, DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningTimeline extends Layout {
    buttonFilter: Button;
    buttonSnapTo: Button;
    layoutOPTimelineTools: OrderPlanningActions;
    layoutPlanningTitle: PlanningTitle;
    panelProfile: Panel;
    panelTimelineFilters: Panel;
    sourceEquipMove: DataSource;
    sourceOrderPlanningProfile: DataSource;
    tableTimeline: Table;
    textboxEndDate: Textbox;
    textboxHours: Textbox;
    textboxId: Textbox;
    textboxStartDate: Textbox;
}
